export const GATED_MEASURES_KEY = 'gated_measures';
export const GATING_MEASURE_KEY = 'gating_measure';
export const RULE_TYPE_KEY = 'rule_type';
export const DISCONTINUE_KEY = 'discontinue';
export const TESTED_OUT_KEY = 'tested-out';

export const RULE_TYPES = {
    [DISCONTINUE_KEY]: 'DISCONTINUE',
    [TESTED_OUT_KEY]: 'TESTED_OUT',
};
